<template>
  <div id="app">

      <div class="tc-header">
          <div class="container-fluid">
              <BuiltProgress></BuiltProgress>
              <BuiltNavigation :next="nextEnabled"></BuiltNavigation>
          </div>
      </div>

      <div class="tc-content">
          <div class="container-fluid">
              <div class="done" v-if="done">
                  <div class="text h4">{{ donetxt }}</div>

                  <button class="btn" @click="$store.dispatch('next')">Create a new tile</button>
              </div>

              <transition name="fade" mode="out-in">
                  <component v-if="!done && currentStep" :is="currentStep.component" @hook:mounted="nextEnabled = false" @ready="nextEnabled = $event" :formtxt="formtxt"></component>
              </transition>

          </div>
      </div>

  </div>
</template>

<script>
import BuiltProgress from './components/BuiltProgress.vue'
import BuiltNavigation from './components/BuiltNavigation.vue'
import TilePattern from './components/TilePattern.vue'
import TileColors from './components/TileColors.vue'
import TileLayout from './components/TileLayout.vue'
import TileSubmit from './components/TileSubmit.vue'

export default {
  props: [
      'patterns',
      'pallete',
      'formtxt',
      'donetxt'
  ],
  name: 'app',
  data(){
      return {
          nextEnabled: false
      }
  },
  components: {
      BuiltProgress,
      BuiltNavigation,
      TilePattern,
      TileColors,
      TileLayout,
      TileSubmit
  },
  computed: {
      done(){
        return this.$store.state.done;
      },
      currentStep(){
          return this.$store.state.step;
      }
  },
    beforeMount(){

      let patterns = JSON.parse(this.patterns);
      let pallete = JSON.parse(this.pallete);

      this.$store.commit('setPatterns', patterns);

      this.$store.commit('setPallete', pallete);

      this.$store.commit('setStep', this.$store.state.steps[0]);

    }
}
</script>

<style lang="less" scoped>
    .tc-content{
        position: relative;
        padding: 15px 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s ease;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .done{
        text-align: center;

        .text, .btn{
            margin-top: 25px;
        }

        .btn{
            background-color: cornflowerblue;
            color: #fff;
            padding: 10px 25px;
        }
    }
</style>
